import { Directive, HostBinding, Input } from '@angular/core';

export type WizardActionButtonVariant = 'secondary' | 'primary' | 'success' | 'danger';
export type WizardActionButtonSize = 'small' | 'medium' | 'large';

@Directive({
    selector: 'button[app-wizard-action-button]',
    standalone: false
})
export class WizardActionButtonDirective {
    @Input('app-wizard-action-button') variant: WizardActionButtonVariant = 'secondary';
    @Input() size: WizardActionButtonSize = 'medium';
    @Input() busy = false;

    @HostBinding('class')
    get hostClass(): string {
        return [
            'inline-flex items-center justify-center gap-2 rounded-md font-semibold transition disabled:cursor-not-allowed disabled:opacity-50',
            this.sizeClass,
            this.variantClass,
            this.busy ? 'cursor-wait opacity-80' : ''
        ].join(' ');
    }

    private get sizeClass(): string {
        switch (this.size) {
            case 'small':
                return 'h-10 px-3.5 text-xs';
            case 'large':
                return 'h-12 px-5 text-sm';
            default:
                return 'h-10 px-4 text-sm';
        }
    }

    private get variantClass(): string {
        switch (this.variant) {
            case 'primary':
                return 'border border-sky-500 bg-sky-500 text-white hover:bg-sky-600';
            case 'success':
                return 'border border-emerald-500 bg-emerald-500 text-white hover:bg-emerald-600';
            case 'danger':
                return 'border border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100';
            default:
                return 'border border-white/60 bg-white/60 text-slate-700 hover:bg-white/90';
        }
    }
}
